module.exports = __webpack_public_path__ + "static/media/Diligent-ACL-logo.7ca45543.png";